import { useMemo } from "react";
import { useLocation } from "react-router-dom";

export default function useQueryString() {
  const { search } = useLocation();
  const urlParse = useMemo(() => new URLSearchParams(search), [search]);

  return urlParse;
}
